var _slicedToArray = require("/Users/nakahashitakayuki/dev/works/ns-recrenewal/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/es.string.trim-end.js");

var _require = require('../library'),
    get = _require.get,
    createInvariantWithPrefix = _require.createInvariantWithPrefix,
    memoize = _require.memoize;

var _require2 = require('../core'),
    createBreakpoints = _require2.createBreakpoints;

var defaultOptions = {
  errorPrefix: '[styled-breakpoints]: ',
  pathToMediaQueries: 'breakpoints',
  defaultBreakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px'
  }
};

exports.createStyledBreakpoints = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var invariant = createInvariantWithPrefix(options.errorPrefix);
  var checkAllValuesHasPixels = memoize(function (breakpoints) {
    var invalidBreakpoints = Object.entries(breakpoints).reduce(function (acc, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var hasPx = /^\d+px$/;

      if (!hasPx.test(value)) {
        acc += "".concat(key, ": ").concat(value, ", ");
      }

      return acc;
    }, '');
    invariant(invalidBreakpoints.length === 0, "Check your theme. `".concat(invalidBreakpoints.trimEnd(), "` are invalid breakpoints. Use only pixels."));
  });

  var getMediaQueriesFromTheme = function getMediaQueriesFromTheme(_ref3) {
    var _ref3$theme = _ref3.theme,
        theme = _ref3$theme === void 0 ? {} : _ref3$theme;
    var memoizedGet = memoize(get);
    var memoizedMediaQueries = memoizedGet(theme, options.pathToMediaQueries, options.defaultBreakpoints);
    checkAllValuesHasPixels(memoizedMediaQueries);
    return memoizedMediaQueries;
  };

  var withBreakpoints = function withBreakpoints(fn) {
    return function (props) {
      var mediaQueriesFromTheme = getMediaQueriesFromTheme(props);
      var breakpoints = createBreakpoints({
        breakpoints: mediaQueriesFromTheme,
        errorPrefix: options.errorPrefix
      });
      return fn(breakpoints);
    };
  };

  var checkIsValidOrientation = function checkIsValidOrientation(x) {
    var validOrientations = x === 'portrait' || x === 'landscape';
    invariant(validOrientations, "`".concat(x, "` is invalid orientation. Use `landscape` or `portrait`."));
  };

  var withOrientation = function withOrientation(mediaQuery, orientation) {
    checkIsValidOrientation(orientation);
    return "".concat(mediaQuery, " and (orientation: ").concat(orientation, ")");
  };

  var withOrientationOrNot = memoize(function (orientation, result) {
    return orientation ? withOrientation(result, orientation) : result;
  });

  var withMinAndMaxMedia = function withMinAndMaxMedia(_ref4) {
    var min = _ref4.min,
        max = _ref4.max;
    return "@media (min-width: ".concat(min, ") and (max-width: ").concat(max, ")");
  };

  return {
    up: function up(name, orientation) {
      return withBreakpoints(function (_ref5) {
        var up = _ref5.up;
        return withOrientationOrNot(orientation, "@media (min-width: ".concat(up(name), ")"));
      });
    },
    down: function down(name, orientation) {
      return withBreakpoints(function (_ref6) {
        var down = _ref6.down;
        return withOrientationOrNot(orientation, "@media (max-width: ".concat(down(name), ")"));
      });
    },
    between: function between(min, max, orientation) {
      return withBreakpoints(function (_ref7) {
        var between = _ref7.between;
        return withOrientationOrNot(orientation, withMinAndMaxMedia(between(min, max)));
      });
    },
    only: function only(name, orientation) {
      return withBreakpoints(function (_ref8) {
        var only = _ref8.only;
        return withOrientationOrNot(orientation, withMinAndMaxMedia(only(name)));
      });
    }
  };
};